import { UI, IconButtonTypes } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

type ResponsiveSuccessIconButtonProps = Partial<IconButtonTypes.Props>;

export const ResponsiveSuccessIconButton: React.FC<ResponsiveSuccessIconButtonProps> = (props) => {
  return (
    <UI.IconButton
      testId="selected-product-confirm"
      icon="Check"
      iconColor="neutral.white"
      iconSize="xs"
      backgroundColor="feedback.success.default"
      borderRadius={BoxRadius.sm}
      h="38px"
      w="40px"
      {...props}
    />
  );
};
